import { useMemo } from "react"
import { capitalizeString } from "src/shared/hooks/capitalizeString"

export function useHeader(data) {
    const getFilterOptions = (key: string) => {
        const options: any[] = []

        data?.forEach((item) => {
            let value = ""
            if (key === "numero_habitacion") {
                value = item?.habitacion?.numero_habitacion
            } else {
                value = item?.[key]
            }
            if (value) {
                const find = options.find((item) => item?.value === value)
                if (!find) options.push({ value, valueToDisplay: capitalizeString(value) })
            }
        })

        return options.length > 0 ? [...options] : []
    }

    const headers = useMemo(() => {
        const base = [
            { value: "Folio" },
            { value: "Estatus", filterMenu: getFilterOptions("estado") },
            { value: "Fecha de registro" },
            { value: "Lugar o responsable", filterMenu: getFilterOptions("area") },
            { value: "Tipo", filterMenu: getFilterOptions("tipo_incidencia") },
            { value: "Habitación", filterMenu: getFilterOptions("numero_habitacion") },
            { value: "Matrícula" },
            { value: "Descripción" },
            { value: "Urgencia", filterMenu: getFilterOptions("severidad") },
        ]
        return base
    }, [data])

    return headers
}
